/* ==========================================================================
   WarGrounds — cross-sell du tiroir panier + upsell de la page panier

   Volontairement decouple de wg-theme.js : ce fichier n'y touche pas.
   Il observe le conteneur des lignes du tiroir, que wgDrawerRender() vide et
   remplit a chaque rendu, et se redeclenche a ce moment-la.

   Pour tout annuler : retirer la ligne script du snippet wg-mobile-cro.liquid.
   ========================================================================== */
(function () {
  'use strict';

  /* v1.9 : textes fournis par window.wgI18n (layout/theme.liquid, filtre t, 4 langues). */
  var I18N = window.wgI18n || {};
  var TXT = {
    head: I18N.xsell_head || 'Complétez votre commande',
    add: I18N.xsell_add || 'Ajouter',
    lot: I18N.xsell_lot || 'lot de %n%'
  };

  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function threshold() {
    var badge = document.querySelector('[data-wg-cart-count]');
    return parseInt((badge && badge.dataset.freeShipping) || '8000', 10);
  }

  /* Sous-total des articles : total_price de cart/change.js inclut le port estimé (voir wg-theme.js). */
  function cartSub(cart) {
    return typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price;
  }

  var catalogue = null;
  function getCatalogue() {
    if (catalogue) return catalogue;
    var node = document.querySelector('[data-wg-xsell]');
    if (!node) return (catalogue = []);
    try { catalogue = JSON.parse(node.textContent) || []; }
    catch (e) { catalogue = []; }
    return catalogue;
  }

  /* Choix des suggestions du tiroir.
     1. On ecarte ce qui est deja au panier.
     2. On privilegie l'univers deja choisi : le client construit une armee.
     3. A univers egal, l'article qui rapproche le plus du seuil de franco. */
  function pick(cart, max) {
    var items = getCatalogue();
    if (!items.length) return [];

    var inCart = {};
    var gammeScore = {};
    cart.items.forEach(function (it) {
      inCart[it.handle] = true;
      items.forEach(function (c) {
        if (c.g && it.handle && it.handle.indexOf(c.g) === 0) {
          gammeScore[c.g] = (gammeScore[c.g] || 0) + it.quantity;
        }
      });
    });

    var missing = Math.max(0, threshold() - cartSub(cart));

    return items
      .filter(function (c) { return !inCart[c.h]; })
      .map(function (c) {
        var sameGamme = gammeScore[c.g] ? 1 : 0;
        var fit = missing > 0 ? Math.abs(missing - c.p) : c.p;
        return { c: c, sameGamme: sameGamme, fit: fit };
      })
      .sort(function (a, b) {
        if (a.sameGamme !== b.sameGamme) return b.sameGamme - a.sameGamme;
        return a.fit - b.fit;
      })
      .slice(0, max)
      .map(function (x) { return x.c; });
  }

  /* Ajout au panier — on ne refait pas le travail du theme.
     wg-theme.js attache deja un gestionnaire d'ajout AJAX a tout formulaire
     [action$="/cart/add"] present au chargement. Le snippet du tiroir en pose
     un, vide et cache, situe HORS du formulaire du panier. On le remplit et on
     le soumet : le theme fait l'ajout et rafraichit tout le reste.
     Sur /cart, son gestionnaire recharge la page — comportement voulu. */
  function addToCart(id, btn) {
    var form = document.querySelector('[data-wg-xsell-form]');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    idInput.value = id;

    if (btn) {
      btn.disabled = true;
      setTimeout(function () { btn.disabled = false; }, 2500);
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  /* PAGE PANIER — boutons « + » de l'upsell.
     Ils ne peuvent pas etre des <form> : ils seraient imbriques dans le
     <form action="/cart"> du panier, ce que HTML interdit. La </form> interne
     refermait le panier et privait le bouton « Finaliser ma commande » de son
     formulaire — il ne declenchait plus rien. Ce sont donc de simples boutons,
     relayes ici vers le formulaire cache du tiroir. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-wg-cart-add]') : null;
    if (!b) return;
    e.preventDefault();
    addToCart(b.getAttribute('data-wg-cart-add'), b);
  });

  function render(cart) {
    var box = document.querySelector('[data-wg-xsell-box]');
    var list = document.querySelector('[data-wg-xsell-items]');
    if (!box || !list) return;

    if (!cart || cart.item_count === 0) { box.hidden = true; return; }

    var picks = pick(cart, 2);
    if (!picks.length) { box.hidden = true; return; }

    list.textContent = '';
    picks.forEach(function (c) {
      var row = document.createElement('div');
      row.className = 'wg-xsell__item';

      var img = document.createElement('img');
      img.src = c.img || '';
      img.alt = '';
      img.width = 44; img.height = 44; img.loading = 'lazy';
      if (!c.img) img.style.visibility = 'hidden';
      row.appendChild(img);

      var txt = document.createElement('div');
      txt.className = 'wg-xsell__txt';
      var b = document.createElement('b');
      b.textContent = (c.t || '').replace(/^Socles\s+/i, '');
      var small = document.createElement('small');
      small.textContent = c.lot && c.lot > 1
        ? TXT.lot.replace('%n%', c.lot) + ' · ' + euros(c.p)
        : euros(c.p);
      txt.appendChild(b); txt.appendChild(small);
      row.appendChild(txt);

      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'wg-xsell__add';
      add.textContent = '+ ' + TXT.add;
      add.setAttribute('aria-label', TXT.add + ' — ' + c.t);
      add.addEventListener('click', function () { addToCart(c.id, add); });
      row.appendChild(add);

      list.appendChild(row);
    });

    var head = box.querySelector('.wg-xsell__head');
    if (head) head.textContent = TXT.head;
    box.hidden = false;
  }

  /* Note de precommande du tiroir : visible si une ligne du panier figure dans la liste du snippet. */
  function preNote(cart) {
    var note = document.querySelector('[data-wg-pre-note]');
    if (!note) return;
    var handles = (note.getAttribute('data-handles') || '').split(',');
    note.hidden = !(cart && cart.items && cart.items.some(function (it) { return handles.indexOf(it.handle) !== -1; }));
  }

  function refresh() {
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { preNote(cart); render(cart); })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    var lines = document.querySelector('[data-wg-drawer-lines]');
    if (!lines) return;

    var pending = null;
    var obs = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(refresh, 60);
    });
    obs.observe(lines, { childList: true });
  });
})();
